<div class="loading-indicator">
  <p-progressSpinner [strokeWidth]="5" [style]="{width: '2em'}"></p-progressSpinner>
</div>
